import axios from "../api";

const BASE = "/api/knowledge-base";

/* -------------------------------------------------------------------------- */
/*                              MODULE                                          */
/* -------------------------------------------------------------------------- */

/**
 * Fetch all active modules for the dropdown (slug + moduleName pairs).
 */
export const getModulesAction = async () => {
  return new Promise((resolve, reject) => {
    axios
      .get(`${BASE}/modules`)
      .then((res) => {
        // console.log(res.data.data.data)
        resolve(res?.data?.data?.data ?? [])})
      .catch((err) => reject(err?.response?.data ?? err));
  });
};

/* -------------------------------------------------------------------------- */
/*                            TUTORIAL CRUD                                    */
/* -------------------------------------------------------------------------- */

export const uploadKnowledgeBaseAttachmentsAction = async (files) => {
  const formData = new FormData();
  Array.from(files).forEach((file) => formData.append("attachments", file));
  return new Promise((resolve, reject) => {
    axios
      .post(`${BASE}/upload-attachments`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => resolve(res?.data?.data?.data?.urls ?? []))
      .catch((err) => reject(err?.response?.data ?? err));
  });
};

/**
 * List tutorials with optional filters.
 * @param {{ search?: string, moduleSlug?: string, uploadStatus?: string }} filters
 */
export const listTutorialsAction = async (filters = {}) => {
  return new Promise((resolve, reject) => {
    axios
      .post(`${BASE}/tutorials/list`, filters)
      .then((res) => {
        // console.log(res.data.data.data)
        resolve(res?.data?.data?.data ?? [])})
      .catch((err) => reject(err?.response?.data ?? err));
  });
};

/**
 * Get single tutorial by ID.
 * @param {number} id
 */
export const getTutorialByIdAction = async (id) => {
  return new Promise((resolve, reject) => {
    axios
      .get(`${BASE}/tutorials/${id}`)
      .then((res) => {
        // console.log(res.data.data.data)
        resolve(res?.data?.data?.data ?? [])})
      .catch((err) => reject(err?.response?.data ?? err));
  });
};

/**
 * Create a new tutorial. Sends multipart/form-data when a video file is present.
 * @param {object} data - Tutorial payload (title, moduleSlug, videoSourceType, videoUrl, etc.)
 * @param {File|null} file - Video file for file-type tutorials
 */
export const createTutorialAction = async (data, file = null) => {
  if (file) {
    const formData = new FormData();
    // Stringify data so it survives multipart body parsing
    Object.entries(data).forEach(([k, v]) => {
      if (v != null) formData.append(k, typeof v === "object" ? JSON.stringify(v) : String(v));
    });
    formData.append("videoFile", file);

    return new Promise((resolve, reject) => {
      axios
        .post(`${BASE}/tutorials`, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then((res) => {
          // console.log(res.data.data)
          resolve(res?.data?.data)})
        .catch((err) => reject(err?.response?.data ?? err));
    });
  }

  return new Promise((resolve, reject) => {
    axios
      .post(`${BASE}/tutorials`, data)
      .then((res) => {
        // console.log(res.data.data)
        resolve(res?.data?.data)})
      .catch((err) => reject(err?.response?.data ?? err));
  });
};

/**
 * Update a tutorial by ID.
 * @param {number} id
 * @param {object} data
 * @param {File|null} file
 */
export const updateTutorialAction = async (id, data, file = null) => {
  if (file) {
    const formData = new FormData();
    Object.entries(data).forEach(([k, v]) => {
      if (v != null) formData.append(k, typeof v === "object" ? JSON.stringify(v) : String(v));
    });
    formData.append("videoFile", file);

    return new Promise((resolve, reject) => {
      axios
        .put(`${BASE}/tutorials/${id}`, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then((res) =>{ 
        // console.log(res.data.data)
          
          resolve(res?.data?.data)})

        .catch((err) => reject(err?.response?.data ?? err));
    });
  }

  return new Promise((resolve, reject) => {
    axios
      .put(`${BASE}/tutorials/${id}`, data)
      .then((res) => {
        // console.log(res.data.data)
        
        resolve(res?.data?.data)})
      .catch((err) => reject(err?.response?.data ?? err));
  });
};

/**
 * Soft-delete a tutorial.
 * @param {number} id
 */
export const deleteTutorialAction = async (id) => {
  return new Promise((resolve, reject) => {
    axios
      .delete(`${BASE}/tutorials/${id}`)
      .then((res) => {
        // console.log(res.data.data)
        
        resolve(res?.data)})
      .catch((err) => reject(err?.response?.data ?? err));
  });
};

/**
 * Poll upload status for a file-upload tutorial.
 * @param {number} id
 */
export const getTutorialUploadStatusAction = async (id) => {
  return new Promise((resolve, reject) => {
    axios
      .get(`${BASE}/tutorials/${id}/upload-status`)
      .then((res) =>{
        // console.log(res.data.data)
        
         resolve(res?.data?.data)})
      .catch((err) => reject(err?.response?.data ?? err));
  });
};
/**
 * Get articles by module slug (Page 2 — module listing).
 * @param {string} moduleSlug
 * @param {{ search?: string, page?: number, limit?: number }} params
 */
export const getModuleArticlesAction = async (moduleSlug, params = {}) => {
  return new Promise((resolve, reject) => {
    const query = new URLSearchParams();
    if (params.search) query.append("search", params.search);
    if (params.page) query.append("page", params.page);
    if (params.limit) query.append("limit", params.limit);
    axios
      .get(`${BASE}/module/${moduleSlug}/articles?${query.toString()}`)
      .then((res) => resolve(res?.data?.data?.data ?? {}))
      .catch((err) => reject(err?.response?.data ?? err));
  });
};

/**
 * Get single article for Master article view page.
 * @param {number} id
 */
export const getArticleByIdAction = async (id) => {
  return new Promise((resolve, reject) => {
    axios
      .get(`${BASE}/article/${id}`)
      .then((res) => resolve(res?.data?.data?.data ?? null))
      .catch((err) => reject(err?.response?.data ?? err));
  });
};

/**
 * Get top 6 popular articles (all domains, by helpful count).
 */
export const getPopularArticlesAction = async () => {
  return new Promise((resolve, reject) => {
    axios
      .get(`${BASE}/popular`)
      .then((res) => resolve(res?.data?.data?.data ?? []))
      .catch((err) => reject(err?.response?.data ?? err));
  });
};
